import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IOfferCard } from '../../types';
import { RouterLink } from '@angular/router';
import { PaintDirective } from '../../paint.directive';
import { ImageFallbackDirective } from '../../image-fallback.directive';
import { BucketPipe } from '../../bucket.pipe';

@Component({
  selector: 'offer-item',
  standalone: true,
  imports: [RouterLink, PaintDirective, ImageFallbackDirective, BucketPipe],
  templateUrl: './offer-item.component.html',
  styleUrl: './offer-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfferItemComponent {

  offer = input.required<IOfferCard>();

}
